module.exports = __webpack_public_path__ + "static/icon-payment-mastercard-93a53336a969c91c75fbd78183a6230e.svg";